export default __webpack_public_path__ + "static/media/9.eaf18626.svg";